module.exports = __webpack_public_path__ + "img/103018.29cfa16e.png";